export const FIELD_WIDTH = 150;
export const TEXT_FIELD_WIDTH = 360;
export const FIELD_DEFAULT_LABEL = 'Default';

export const FIELD_REQUIRED_LABEL = 'Required';
